<template>
  <div>
    <div class="container">
      <div class="row">
        <div v-if="success" class="col-md-6 offset-md-3 my-5">
          <div class="card border-0 bg-light">
            <div class="card-body text-center py-5">
              <span>
                <svg
                  viewBox="0 0 24 24"
                  width="56"
                  height="56"
                  stroke="#02A676"
                  stroke-width="1"
                  fill="none"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="css-i6dzq1"
                >
                  <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                  <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
              </span>
              <div v-if="isFree">
                <h5 class="mt-4">{{ 'Access granted' | translate }}</h5>
              </div>
              <div v-else>
                <h5 class="mt-4">{{ 'Payment successful' | translate }}</h5>
              </div>
              <div class="my-5" v-if="['consultation'].includes(type)">
                <h3>{{ 'Please check your inbox' | translate }}. {{ 'An email is on the way' | translate }}.</h3>
                <p class="lead">{{ 'Email contains further instructions' | translate }}.</p>
              </div>
              <a
                :href="redirect"
                class="btn btn-block mt-4"
                :class="{
                  'btn-primary': ['course', 'bundle', 'membership', 'live', 'file'].includes(type),
                  'btn-outline-primary': ['consultation'].includes(type),
                }"
              >
                {{ successCTA }}
              </a>
            </div>
          </div>
        </div>
        <div v-else class="col-md-6 offset-md-3 my-5">
          <div class="card border-0 bg-light" v-if="!error">
            <div class="card-body">
              <div class="text-center">
                <div class="spinner-border ms-3" role="status" aria-hidden="true"></div>

                <h4 class="mt-4">
                  {{ 'Transaction processing...' | translate }}
                </h4>
                <div v-if="warning" class="mt-5">
                  <p>
                    {{ "We haven't received a transaction confirmation yet." | translate }}
                  </p>
                  <p>
                    {{ 'Please check if the transaction registered in your bank account.' | translate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="card border-0 bg-warning mt-3" v-else>
            <div class="card-body text-center">
              <p>{{ 'Your payment did not go through' | translate }}</p>
              <a :href="checkoutLink" class="btn btn-outline-primary">
                {{ 'Go back' | translate }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot v-if="success"></slot>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  props: ['type', 'redirect', 'hash'],
  data() {
    return {
      dataLayerPushed: false,
      gaEventSent: false,
      gtagEventSent: false,
      checkoutLink: '/courses',
      transaction: {},
      status: null,
      success: false,
      warning: false,
      error: false,
      succesfullChecks: 0,
    }
  },
  mounted() {
    this.check()
    this.initiateWarning()
  },
  methods: {
    eraseCookie(name) {
      document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;'
    },
    removeCookies() {
      this.eraseCookie('recomme_crc')
      this.eraseCookie('promo_code')
    },
    facebookConversionEvent() {
      if (typeof fbq === 'undefined') {
        return setTimeout(this.facebookConversionEvent, 2000)
      }

      fbq('track', 'Purchase', conversion, { eventID: this.hash })
    },
    googleConversionEvent() {
      if (typeof gtag_send_to !== 'undefined') {
        gtag_conversion.send_to = gtag_send_to
      }

      if (!this.dataLayerPushed) {
        dataLayer.push({
          event: 'purchase',
          ecommerce: gtag_conversion,
        })
        this.dataLayerPushed = true
      }


      // if (typeof ga !== 'undefined' && !this.gaEventSent) {
      //   ga('event', 'purchase', gtag_conversion)
      //   this.gaEventSent = true
      // }
      // if (typeof gtag !== 'undefined' && !this.gtagEventSent) {
      //   gtag('event', 'purchase', gtag_conversion)
      //   this.gtagEventSent = true
      // }
      // setTimeout(this.googleConversionEvent, 2000)
    },
    initiateWarning() {
      setTimeout(() => {
        if (this.succesfullChecks) {
          this.warning = true
        }
      }, 60000)
    },
    setAnotherCheck() {
      if (_.includes(['PERFORMED', 'CLEARED', 'ACCESS_GRANTED'], this.status)) {
        this.facebookConversionEvent()
        this.googleConversionEvent()
        this.removeCookies()
        this.success = true
      } else if (_.includes(['FAILURE', 'ERROR', 'CANCELED'], this.status)) {
        this.error = true
      } else {
        setTimeout(this.check, 5000)
      }
    },
    check() {
      this.$api
        .checkTransactionStatus(this.hash)
        .then(({ data }) => {
          this.status = data.status
          this.transaction = data.transaction
          this.checkoutLink = data.checkoutLink
          this.succesfullChecks++
        })
        .then(this.setAnotherCheck)
        .catch((error) => {
          if (_.get(error, 'response.status') === 502) {
            this.succesfullChecks++
            this.setAnotherCheck()
          } else {
            this.error = true
            console.error(error)
          }
        })
    },
  },
  computed: {
    isFree() {
      let value = _.get(conversion, 'value', 0)

      if (value === 0) {
        return true
      }
      return false
    },
    successCTA() {
      if (this.transaction.quantity > 1 && _.includes(['course'], this.type)) {
        return this.$t('Manage access')
      } else if (_.includes(['consultation'], this.type)) {
        return this.$t('Go to your product list')
      } else if (_.includes(['file'], this.type)) {
        return this.$t('Go to download')
      }

      return this.$t('Start')
    },
  },
}
</script>
